import React, { useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../store";
import { refreshToken, logOut, initializeLogin } from "../redux/actions/user";
import { JWTRequestStatus } from "../api/auth";

interface AuthProps {
  children: React.ReactNode;
}

const AuthProvider: React.FunctionComponent<AuthProps> = (props: AuthProps) => {
  const isLoggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const dispatch = useDispatch();

  const initLogin = async () => {
    dispatch(initializeLogin());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  // Initialize login
  useEffect(() => {
    initLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refresh token if user is logged in
  useEffect(() => {
    let refreshInterval: number | null = null;
    if (isLoggedIn) {
      refreshInterval = window.setInterval(async () => {
        const result = (await (dispatch(
          refreshToken(),
        ) as any)) as JWTRequestStatus;
        console.log(result);
        // Only log out if it's an actual auth failure, not a network error
        if (
          result.status === "failed" &&
          result.message !== "Server not Found" &&
          result.message !== "Network Error"
        ) {
          console.log("expired token. loged out");
          dispatch(logOut());
        } else {
          console.log("not expired token. not loged out");
        }
      }, 300000);
    }

    return () => {
      if (refreshInterval != null) {
        clearInterval(refreshInterval);
      }
    };
  }, [isLoggedIn]);

  return <>{props.children}</>;
};

export default AuthProvider;
